import { styled } from 'styled-components';
import { Text } from '@property.com.au/ui-kit';
import { typographyHelper } from '@property.com.au/ui-kit';

export const SubBrickTitle = styled(Text)`
  ${typographyHelper('subtitle02')};
  line-height: 1.125rem;
  font-weight: 600;
`;
